/**
 * L'anteprima della key di una voce nuova, con la regola del backend
 * (CrmHelperLocalServiceImpl.toListTypeEntryKey): camelCase, accenti tolti, solo lettere e cifre,
 * «v» davanti se comincia con una cifra, al massimo 75 caratteri. Il numero in coda se la key c'è
 * già lo decide il server.
 */
export function listTypeEntryKey(name: string): string {
  const parole = name
    .normalize('NFD')
    .replace(/\p{M}/gu, '')
    .toLowerCase()
    .split(/[^a-z0-9]+/)
    .filter(Boolean);
  let key = parole.map((p, i) => (i === 0 ? p : p[0].toUpperCase() + p.slice(1))).join('');
  if (/^[0-9]/.test(key)) key = `v${key}`;
  return key.slice(0, 75);
}
